module.exports = __webpack_public_path__ + "img/laoshi.af382230.png";